import React from 'react';
import { FadeIn } from './FadeIn';
export function ProblemSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#141414]" data-id="element-147">
      <div className="max-w-3xl mx-auto" data-id="element-148">
        <FadeIn data-id="element-149">
          <div className="space-y-6 text-base sm:text-lg text-brand-offwhite/80 font-sans leading-relaxed" data-id="element-150">
            <p data-id="element-151">
              Cuando ocurre una infidelidad, el mundo se divide en dos consejos
              inútiles:{' '}
              <span className="text-brand-amber" data-id="element-152">
                «Déjalo de inmediato, ten dignidad»
              </span>{' '}
              o{' '}
              <span className="text-brand-amber" data-id="element-153">
                «Perdona y olvida por los hijos»
              </span>
              .
            </p>
            <p data-id="element-154">
              Ninguno de los dos entiende que hay años de historia, finanzas
              compartidas y un amor que no se apaga con un interruptor. Estás en
              parálisis por análisis. Tu cerebro está en modo supervivencia, tu
              autoestima está por los suelos y cada vez que intentas hablar con
              tu pareja, terminan en una explosión de gritos o en un muro de
              hielo que dura días.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}